export default function invokeFileDownload(responseFile, fileName) {
    const file = window.URL.createObjectURL(new Blob([responseFile]));
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = file;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(file);
}